import React from "react";
import Modal from "react-bootstrap/Modal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import shopLocalDigital from "../../assets/BlackLogo.svg";
import communityXlogo from "../../assets/communityXlogo.svg";
import CheckoutForm from "../../Pages/CheckoutForm/CheckoutForm";
import closeBtn from "../../assets/close-btn.png";

function StripeModal({ onHide, price, SetLoading, CouponData, ...props }) {
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHBALE_KEY
  );

  const options = {
    mode: "payment",
    amount: 1099,
    currency: "usd",
    appearance: {
      theme: "stripe",
      backgroundColor: "#000",
    },
  };
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="stripe_Modal_Main"
      >
        <Modal.Body className="stripe_Modal">
          <img src={closeBtn} className="close_Button" onClick={onHide} />
          <div className="shopLocalDigital_Logo mb-5">
            <img alt="CommunityX Digital" src={communityXlogo} />
          </div>
          <p>Please fill in your card details to proceed.</p>
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm
              amountprice={price}
              setLoading={SetLoading}
              couponData={CouponData}
            />
          </Elements>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default StripeModal;
